import { useStore } from "@nanostores/preact"
import { JSXInternal } from "preact/src/jsx"
import { useEffect, useState } from "preact/hooks"

import {
  profile,
  SubscriptionValue,
  support as supportStore,
} from "components/signup/services/store"
import { TranslationProvider } from "components/signup/components/Translation"
import { getSupport } from "components/signup/services/backend"
import { ErrorScreen } from "components/signup/screens/ErrorScreen"
import { Loading } from "components/signup/screens/LoadingScreen"
import { Support } from "components/signup/services/support"
import { Screens } from "components/signup/services/screens"

import { WeatherSummary } from "./components/WeatherSummary"
import { Subscriptions } from "./screens/Subscriptions"
import css from "./style.module.scss"

export function Incentive({
  onReload,
  onOpenModal,
}: {
  onReload: () => void
  onOpenModal: (page: Screens) => void
}) {
  const [page, setPage] = useState<Screens>(Screens.LoadingScreen)
  const [errorMessage, setErrorMessage] = useState("")
  const support = useStore(supportStore)

  useEffect(() => {
    setErrorMessage("")
    ;(async () => {
      let data: Support
      try {
        data = await getSupport()
      } catch (error) {
        let msg = "fetching support, but the error is unknown"
        if (error instanceof Error) msg = error.message

        setPage(Screens.ErrorScreen)
        setErrorMessage(msg)

        return
      }
      supportStore.set(data)
      profile.setKey("source", "incentive")
      profile.setKey("countryIso", data.default_iso_country)
      profile.setKey("premium", data.user.premium)
      profile.setKey("authorized", data.user.signedIn)
      profile.setKey("emailVerified", data.user.emailVerified)
      profile.setKey("email", data.user.email)
      // console.log(data)
      // console.log(profile.get())
      setPage(Screens.SubscriptionsScreen)
    })()
  }, [])

  let el: JSXInternal.Element
  switch (page) {
    case Screens.LoadingScreen:
      el = (
        <div>
          <Loading />
        </div>
      )
      break
    case Screens.ErrorScreen:
      el = (
        <div>
          <ErrorScreen message={errorMessage} onReload={onReload} />
        </div>
      )
      break
    case Screens.SubscriptionsScreen:
      el = !support ? (
        <Loading />
      ) : (
        <>
          <WeatherSummary />
          <Subscriptions
            experiment={support.experiment}
            onSubmit={(v: SubscriptionValue) => {
              profile.setKey("subscription", v)
              onOpenModal(Screens.LoadingScreen)
            }}
          />
        </>
      )
      break
    default:
      throw new Error(`Unexpected error. Specified page (${page}) is not supported.`)
  }

  return (
    <TranslationProvider definitions={support?.messages}>
      <div className={css.incentive}>{el}</div>
    </TranslationProvider>
  )
}
